var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"slider"},[_c('div',{class:['slide slide2', _vm.slideUp]},[_c('img',{attrs:{"src":'/img/TN_BRANCO.png',"width":"400","alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }